import htheme_pagebuilder from '../htheme/pagebuilder/pagebuilder.js';
import htheme_header_slider from '../htheme/header/slider.js';
import htheme_favorites from '../htheme/favorites';



export default {
  init() {
    htheme_pagebuilder.init();
    htheme_header_slider.init();
    htheme_favorites.init();
  },
  finalize() {
    var $links = $('.mittagsmenue-content a');
    if ($links.length > 0) {
      $($links).simpleLightbox({
        navText: [
          '<div class="lightbox-prev"></div>',
          '<div class="lightbox-next"></div>',
        ],
        closeText: '<div class="lightbox-close"></div>',
      });
    }
    // tooltips

    $('[data-toggle="tooltip"]').tooltip();

    // JavaScript to be fired on all pages, after page specific JS is fired
    if (window.innerWidth <= 768) {

      $(window).load(() => {
        $('.replace-vh').each((i, e) => {
          $(e).css('height', $(e).outerHeight());
        });
      });
    }

    $('.wmtm-icon-burger a').on('click', (e) => {
      var menuItem = $(e.currentTarget).parent();
      menuItem.toggleClass('wmtm-icon-burger--open');
      $('.wmtm-navbar-mobile').toggleClass('show-drawer');
      $('#wmtm-mobile-drawer').slideToggle(200);
      e.preventDefault();
    });

    $(window).on('scroll', () => {
      // 0 == false
      if ($(window).scrollTop()) {
        $('body').addClass('wmtm-scrolled');
      } else {
        $('body').removeClass('wmtm-scrolled');
      }
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js